import {appTheme} from "../styles/AppTheme";
import {SnackbarProvider} from "notistack";
import {ErrorBoundary} from "./ErrorBoundary";
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";
import {ConsultaCartao} from "./Consulta";
import {ThemeProvider} from "@mui/material/styles";
import React, {useMemo} from "react";

export default function Main() {
    const gPublicKey = useMemo(() => document.querySelector('meta[name="gPublicKey"]')
        .getAttribute('content'), []);
    return <ThemeProvider theme={appTheme}>
        <SnackbarProvider maxSnack={1}>
            <ErrorBoundary>
                <GoogleReCaptchaProvider
                    reCaptchaKey={gPublicKey} scriptProps={{defer: true}}>
                    <ConsultaCartao/>
                </GoogleReCaptchaProvider>
            </ErrorBoundary>
        </SnackbarProvider>
    </ThemeProvider>
}